import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../api/client.jsx';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * Metered-Billing: Abrechnungsläufe (usage_billing_runs) einsehen.
 * Backend: GET /v1/admin/usage-runs  (+ /:id für die Zeilen).
 */
export function useUsageRuns({ subscriptionId, status } = {}) {
  const { fetch } = useApiClient();
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['usage-runs', fixturesMode ? 'fixture' : 'live', subscriptionId ?? null, status ?? null],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return { runs: [] }; }
      const qs = new URLSearchParams();
      if (subscriptionId) qs.set('subscription_id', String(subscriptionId));
      if (status) qs.set('status', status);
      const suffix = qs.toString() ? `?${qs}` : '';
      return fetch(`/v1/admin/usage-runs${suffix}`);
    },
  });
}

export function useUsageRun(id) {
  const { fetch } = useApiClient();
  const fixturesMode = useFixturesMode();
  return useQuery({
    enabled: id != null,
    queryKey: ['usage-run', fixturesMode ? 'fixture' : 'live', id ?? null],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return { run: null }; }
      return fetch(`/v1/admin/usage-runs/${id}`);
    },
  });
}
